import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { WALLET } from '@blink/components/src/types';

import { useInstalledWallets } from './useInstalledWallets';

import { addWalletsSaga, disconnectPreviousWallet } from '@/shared/store/wallets/actions';
import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';

export const useHandleConnectWallet = (
    selectedWallet: WALLET | null,
    handleCloseModal: () => void,
) => {
    const dispatch = useDispatch();
    const { isMetaMaskWalletInstalled, isRabbyBaseWalletInstalled } = useInstalledWallets();

    return useCallback(() => {
        if (!selectedWallet) return;

        if (selectedWallet === WALLET.META_MASK && !isMetaMaskWalletInstalled) {
            return dispatch(showModalAction({ modalName: ModalName.METAMASK_NOT_INSTALLED_MODAL }));
        }

        if (selectedWallet === WALLET.RABBY && !isRabbyBaseWalletInstalled) {
            return dispatch(showModalAction({ modalName: ModalName.RABBY_NOT_INSTALLED_MODAL }));
        }

        dispatch(disconnectPreviousWallet());
        dispatch(addWalletsSaga(selectedWallet));
        handleCloseModal();
    }, [
        selectedWallet,
        isMetaMaskWalletInstalled,
        isRabbyBaseWalletInstalled,
        dispatch,
        handleCloseModal,
    ]);
};
